import queryString from "query-string";

import {
  AUCTION_PEN,
  BILLING_DOCUMENT,
  BUSINESS,
  MLA_SUPPLEMENTARY_DATA,
  SALE_LOT,
} from "constants/actionTypes";
import {
  BulkUpdateModelActions,
  BulkUpdateModel,
} from "constants/bulkUpdateModels";

import { getLivestockSaleId } from "lib/navigation";
import { serializeAuctionPen } from "lib/serializers/auctionPens";
import { serializeBillingDocument } from "lib/serializers/billingDocuments";
import { serializeBusiness } from "lib/serializers/businesses";
import { serializeMLASupplementaryData } from "lib/serializers/mlaSupplementaryData";
import { serializeBulkUpdateSaleLot } from "lib/serializers/saleLot";

export const bulkUpdate = (
  model,
  payload,
  baseAction,
  options = {
    changeReason: null,
    suppressToast: false,
    suppressErrorToast: false,
    suppressSuccessToast: false,
  },
) => {
  const livestockSaleId = getLivestockSaleId();
  return {
    type: baseAction.REQUEST,
    model,
    payload,
    meta: {
      offline: {
        effect: {
          url: queryString.stringifyUrl({
            url: `/v2/${model}/bulk_update/`,
            query: {
              livestock_sale_id: livestockSaleId,
            },
          }),
          method: "PATCH",
          body: JSON.stringify(payload),
          options,
          changeReason: options.changeReason,
        },
        commit: {
          type: baseAction.SUCCESS,
          model,
          options,
        },
        rollback: {
          type: baseAction.FAILURE,
          model,
          options,
        },
      },
    },
  };
};

export const bulkUpdateAuctionPen = auctionPens => {
  const model = BulkUpdateModel.AUCTION_PEN;
  const objects = auctionPens.map(serializeAuctionPen);
  const baseAction = AUCTION_PEN.UPDATE_BULK;
  return bulkUpdate(model, objects, baseAction);
};

export const bulkUpdateSaleLots = saleLots => {
  const model = BulkUpdateModel.SALE_LOT;
  const objects = saleLots.map(serializeBulkUpdateSaleLot);
  const baseAction = SALE_LOT.UPDATE_BULK;
  return bulkUpdate(model, objects, baseAction);
};

/**
 * @param {Array<SaleLot>} saleLots
 */
export const bulkUpdateSaleLotsActionCreator = (payload, options) => {
  const model = BulkUpdateModel.SALE_LOT_SERIALIZER;
  const serializedPayload = payload.map(serializeBulkUpdateSaleLot);
  const baseAction = SALE_LOT.UPDATE_BULK;
  return bulkUpdate(model, serializedPayload, baseAction, options);
};

export const bulkUpdateBillingDocuments = billingDocuments => {
  const model = BulkUpdateModel.BILLING_DOCUMENT;
  const objects = billingDocuments.map(serializeBillingDocument);
  const baseAction = BILLING_DOCUMENT.UPDATE_BULK;
  return bulkUpdate(model, objects, baseAction);
};

export const bulkUpdateMLASupplementaryData = mlaSupplementaryData => {
  const model = BulkUpdateModel.MLA_SUPPLEMENTARY_DATA;
  const objects = mlaSupplementaryData.map(serializeMLASupplementaryData);
  const baseAction = MLA_SUPPLEMENTARY_DATA.UPDATE_BULK;
  return bulkUpdate(model, objects, baseAction);
};

export const bulkUpdateBusinesses = businesses => {
  const model = BulkUpdateModel.BUSINESS;
  const objects = businesses.map(serializeBusiness);
  const baseAction = BUSINESS.UPDATE_BULK;
  return bulkUpdate(model, objects, baseAction);
};

export const bulkUpdateFromSocket = message => {
  const { model, objects } = message.object;
  const baseAction = BulkUpdateModelActions[model];
  return {
    type: baseAction.FROM_SOCKET,
    model,
    payload: objects,
  };
};
